import React from 'react';
import {Button} from 'react-bootstrap';

let ReadAllButton = (props) => {
  const handleReadAllClick = () => {
    props.onReadAll();
  };

  return <Button variant="primary" size="sm"
                 title={gettext('Отметить все как прочитанные')}
                 disabled={!props.count}
                 onClick={handleReadAllClick}>
    <span className="icon icon-ok-circled2"></span> {gettext('Отметить все как прочитанные')} ({props.count})
  </Button>
};
export default ReadAllButton;